import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c0d1c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center mt-4" }

import farmaciAggiuntiveEdit from '@/views/Farmaci/farmaciAggiuntiveEdit.vue'
import farmaciModalConfidenzialita from '@/views/Farmaci/farmaciModalConfidenzialita.vue'
import farmaciModalSposta from '@/views/Farmaci/farmaciModalSposta.vue'
import { saveTerapia, saveAdverseReaction } from '@/../../EshJSLib/services/farmaciServices';
import CollapsibleItem from '@/layout/collapsible/CollapsibleItem.vue';
import { CollapsableModel } from '@/../../EshJSLib/models/CollapsableModel';
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import farmaci from '@/../../EshJSLib/models/form/farmaci.json';
import farmaciConclusi from '@/../../EshJSLib/models/form/farmaciConclusi.json';
import farmacivietati from '@/../../EshJSLib/models/form/farmacivietati.json';
import { AdverseReactions, TblTerapie } from '@/../../EshJSLib/models/patient'
import { ref, onMounted, reactive } from 'vue'
import AlertModal from "@/components/AlertModalFeedback.vue";
import axios from 'axios';
import farmaciModalAdverseReactions from '@/views/Farmaci/farmaciModalAdverseReactions.vue'
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import { hasPermission } from '../../../../EshJSLib/services/securityServices';

//Ref Element with HTML

export default /*#__PURE__*/_defineComponent({
  __name: 'FarmaciPage',
  props: {
  tipo: Number,
},
  setup(__props) {

const props = __props;

const modalAddEditFarmaci = ref<InstanceType<typeof farmaciAggiuntiveEdit> | null>(null);
const modalConfidenzialita = ref<InstanceType<typeof farmaciModalConfidenzialita> | null>(null);
const modalSposta = ref<InstanceType<typeof farmaciModalSposta> | null>(null);
const modalAdverseReactions = ref<InstanceType<typeof farmaciModalAdverseReactions> | null>(null);
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);

// Constant 
const store = patientStore();
const { patient } = storeToRefs(store)
const showLoading = ref(false);


const router = useRouter();
const isShownModalSub = reactive({
  alert: false,
  movePage: false,
  confirm: false,
  alertMove: false,
});

function movePage() {
  router.push({ path: 'Paypal' })
}



onMounted(async () => {
  store.fetchFarmaci();
  store.fetchDiagnosi();
  store.fetchAdverseReaction();
})


async function saveAndRefreshFarmaci(userInput: boolean, row: TblTerapie) {
  if (userInput) {
    showLoading.value = true;

    saveTerapia(row)
      .then((response) => {
        // Mostra subito l'alertModal con il messaggio dell'API (successo)
        const message = response?.data?.message || "Operazione completata con successo";
        alertModal.value.openModal(message, false); // Mostra il messaggio di successo

        // Esegui il fetch dei farmaci dopo aver mostrato l'alertModal
        store.fetchFarmaci().finally(() => {
          showLoading.value = false;
        });
      })
      .catch((error) => {
        // Gestisci l'errore e mostra subito l'alertModal con il messaggio di errore
        const errorMessage = error.response?.data?.message || "Siamo spiacenti, si è verificato un errore. La preghiamo di riprovare più tardi";
        alertModal.value.openModal(errorMessage, false); // Mostra il messaggio di errore
        showLoading.value = false; // Assicurati che il loading finisca anche in caso di errore
      });
  } else { store.fetchFarmaci(); }

}

async function saveAndRefreshAdverse(userInput: boolean, row: AdverseReactions) {
  if (userInput) {
    showLoading.value = true;
    saveAdverseReaction(row).then((x) => {
      store.fetchAdverseReaction().then(() => {
        showLoading.value = false;
      })
    }).catch((error) => {
      showLoading.value = false;
      alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false)

    })

  } else { store.fetchAdverseReaction(); }
}

let adverse = {} as AdverseReactions;



async function action(type: string, row: TblTerapie, index: number, table: string) {
  let userInput = false;

  switch (type) {
    case "add":
      //  var id_tipo_licenza = patient.value.sottoscrizione.id_tipo_licenza
      if (await hasPermission('aggiungifarmaci')) {
        row = {} as TblTerapie
        row.id_terapie = 0
        row.id_paziente = patient.value.id_paziente
        row.id_livello_confidenzialita = 6
        row.terapie_stato = table
        row.tipo_terapia = table
        row.status = 'add'
        userInput = await modalAddEditFarmaci.value?.openModal("Crea Farmaco", row);
        saveAndRefreshFarmaci(userInput, row)
      } else {
        isShownModalSub.alert = true;
      }
      break;
    case "pen":
      if (await hasPermission('modificafarmaci')) {
        row.status = 'update'
        userInput = await modalAddEditFarmaci.value?.openModal("Modifica Farmaco", row);
        saveAndRefreshFarmaci(userInput, row)
      } else {
        isShownModalSub.alert = true;
      }
      break;

    case "lock":
      row.status = 'update'
      userInput = await modalConfidenzialita.value?.openModal("Modifica Confidenzialita'", row);
      saveAndRefreshFarmaci(userInput, row)
      break;

    case "up-down":
      if (await hasPermission('spostaFarmaci')) {
        row.status = 'update'
        userInput = await modalSposta.value?.openModal("Sposta", row);
        saveAndRefreshFarmaci(userInput, row)
      } else {
        isShownModalSub.alert = true;
      }
      break;

    case 'trash':
      alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then((userInput) => {
        row.status = 'delete'
        saveAndRefreshFarmaci(userInput, row)
      })
      break;

    case 'exclamation':
      //adverse.status = 'update'
      adverse = {} as AdverseReactions
      adverse.id_utente = patient.value.id_paziente;
      adverse.id_terapie = row.id_terapie;
      userInput = await modalAdverseReactions.value?.openModal("Adverse Reactions", adverse);
      saveAndRefreshAdverse(userInput, adverse)
      break;

    case 'info':
      axios.get(`/farmacoDetails/` + row.id_farmaco_codifa).then((response) => {
        window.open(`/farmacoDetails/` + row.id_farmaco_codifa);
      }, (error) => {
        alertModal.value.openModal('Nessuna informazione di dettaglio per questo farmaco', false);
      })
      break;
  }
}




return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(farmaciAggiuntiveEdit, {
          ref_key: "modalAddEditFarmaci",
          ref: modalAddEditFarmaci
        }, null, 512),
        _createVNode(farmaciModalConfidenzialita, {
          ref_key: "modalConfidenzialita",
          ref: modalConfidenzialita
        }, null, 512),
        _createVNode(farmaciModalSposta, {
          ref_key: "modalSposta",
          ref: modalSposta
        }, null, 512),
        _createVNode(farmaciModalAdverseReactions, {
          ref_key: "modalAdverseReactions",
          ref: modalAdverseReactions
        }, null, 512),
        _createVNode(CollapsibleItem, {
          data: _unref(farmaci),
          onRowActions: _cache[0] || (_cache[0] = (n, r, i) => action(n, r, i, 'terapie_inuso')),
          onCreateForm: _cache[1] || (_cache[1] = ($event: any) => (action('add', null, 1, '1')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          data: _unref(farmaciConclusi),
          onRowActions: _cache[2] || (_cache[2] = (n, r, i) => action(n, r, i, 'terapie_Conclusi')),
          onCreateForm: _cache[3] || (_cache[3] = ($event: any) => (action('add', null, 2, '2')))
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          data: _unref(farmacivietati),
          onRowActions: _cache[4] || (_cache[4] = (n, r, i) => action(n, r, i, 'terapie_Vietati')),
          onCreateForm: _cache[5] || (_cache[5] = ($event: any) => (action('add', null, 0, '0')))
        }, null, 8, ["data"]),
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        (showLoading.value)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
          : _createCommentVNode("", true),
        (isShownModalSub.alert)
          ? (_openBlock(), _createBlock(_unref(Modal), {
              key: 1,
              onClose: _cache[8] || (_cache[8] = ($event: any) => (isShownModalSub.alert = false))
            }, {
              body: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (isShownModalSub.alert = false)),
                    type: "button",
                    class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                  }, _toDisplayString(_ctx.$t("Annulla")), 1),
                  _createElementVNode("button", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (movePage())),
                    type: "button",
                    class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                  }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})